
export { useMediaQuery } from "/vercel/path0/libs/hooks/src/lib/useMediaQuery/useMediaQuery.ts"